<template>
  <div class="container">
    <!-- header -->
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" class="navbar"/>
    <!-- body -->
    <cube-scroll ref="scroll" class="scroll-wrap">
      <div class="form">
        <h2 class="title">基础信息</h2>
        <van-cell-group>
          <van-field v-model="form.username" required label="帐号" placeholder="请输入帐号"/>
          <van-field
            v-model="form.password"
            type="text"
            label="密码"
            :placeholder="passwordPlaceholder"
            :required="merch_id ? false : true"
          />
          <van-field
            v-model="form.notpassword"
            type="text"
            label="确认密码"
            :placeholder="notpasswordPlaceholder"
            :required="merch_id ? false : true"
          />
          <van-field
            label="地区选择"
            placeholder="请选择地区"
            :value="areatext"
            required
            readonly
            @click="onOpenArea"
          />
          <van-field v-model="form.address" label="门店详细地址" placeholder="请输入门店详细地址" required/>
        </van-cell-group>
        <h2 class="title">其他信息(选填)</h2>
        <van-cell-group>
          <van-field v-model="form.mobile" label="手机号码" placeholder="请输入手机号码"/>
          <van-field v-model="form.realname" label="真实姓名" placeholder="请输入真实姓名"/>
          <van-field v-model="form.idcard" label="身份证号" placeholder="请输入身份证号"/>
        </van-cell-group>
        <div class="submit-container">
          <van-button
            v-if="!merch_id"
            size="large"
            type="info"
            class="submit-btn"
            @click="onPost"
          >提交</van-button>
          <van-button
            v-else
            size="large"
            :disabled="disabled"
            type="info"
            class="submit-btn"
            @click="onPost"
          >保存</van-button>
        </div>
      </div>
    </cube-scroll>
    <!-- footer -->
    <slidedown-animation>
      <van-area
        class="vanarea"
        :visible-item-count="6"
        v-if="isopen"
        :area-list="areaList"
        title="选择地区"
        @cancel="onCloseArea"
        @confirm="onSetArea"
      />
    </slidedown-animation>
  </div>
</template>
<script>
import AreaList from "@util/area";
import SlidedownAnimation from "@components/slide/SlidedownAnimation";
import { MerchModel } from "@models/admin/merch";
import { ERR_OK } from "@/common";
import { mapState } from "vuex";

const merchModel = new MerchModel();
export default {
  data() {
    return {
      merch_id: "",
      title: "添加加盟店",
      passwordPlaceholder: "请输入密码",
      notpasswordPlaceholder: "请输入确认密码",
      form: {
        username: "",
        password: "",
        notpassword: "",
        address: "",
        province: "",
        city: "",
        area: "",
        mobile: "",
        realname: "",
        idcard: ""
      },
      areaList: AreaList,
      isopen: false,
      errmsg: {
        usernameErrorMsg: "请输入帐号",
        lenusernameErrorMsg: "帐号不得小于2位",
        passwordErrorMsg: "请输入密码",
        lenpasswordErrorMsg: "密码不得小于6位",
        notpasswordErrorMsg: "请输入确认密码",
        nopasswordErrorMsg: "两次密码输入不一致",
        areaErrorMsg: "请选择地区",
        addressErrorMsg: "请输入门店详细地址",
        phoneErrorMsg: "手机号码有误，请重填"
      },
      disabled: false
    };
  },
  computed: {
    areatext() {
      if (this.form.province && this.form.city && this.form.area) {
        return this.form.province + " " + this.form.city + " " + this.form.area;
      }
    },
    ...mapState(["currIndex", "merch"])
  },
  methods: {
    onClickLeft() {
      this.$redirect("/admin/merch");
    },
    onOpenArea() {
      this.isopen = true;
    },
    onCloseArea() {
      this.isopen = false;
    },
    onSetArea(data) {
      this.form.province = data[0].name;
      this.form.city = data[1].name;
      this.form.area = data[2].name;
      this.onCloseArea();
    },
    onPost() {
      if (this._checkForm() && !this.disabled) {
        this.disabled = true;    
        merchModel
          .post({
            formData: this.form,
            user_token: localStorage.getItem("user_token")
          })
          .then(res => {
            if (res.code == ERR_OK) {
              if (!this.merch_id) {
                this.$dialog
                  .confirm({
                    message: "添加成功",
                    cancelButtonText: "继续添加",
                    confirmButtonText: "返回列表"
                  })
                  .then(() => {
                    this.$setCache('event','add')
                    this.$redirect("/admin/merch")
                    this.disabled = false
                  })
                  .catch(() => {
                    this._resetForm();
                  });
              } else {
                this.$setCache('merch_data',this.form);
                this.$setCache('event','update');
                this.$setCache('data_name','merch_data');
                this.$toast("修改成功!");
                setTimeout(() => {
                  this.$redirect("/admin/merch");
                  this.disabled = false
                }, 3000);
              }
            } else {
              this.$toast(res.msg);
              this.disabled = false;
            }
          });
      }
    },
    _resetForm() {
      this.form.username = "";
      this.form.password = "";
      this.form.notpassword = "";
      this.form.province = "";
      this.form.city = "";
      this.form.area = "";
      this.form.address = "";
      this.form.mobile = "";
      this.form.realname = "";
      this.form.idcard = "";
      this.disabled = false
    },
    _checkForm() {
      if (!this.form.username) {
        this.$toast(this.errmsg.usernameErrorMsg);
        return false;
      }
      if (this.form.username && this.form.username.length < 2) {
        this.$toast(this.errmsg.lenusernameErrorMsg);
        return false;
      }
      if (!this.merch_id) {
        if (!this.form.password) {
          this.$toast(this.errmsg.passwordErrorMsg);
          return false;
        }
        if (this.form.password && this.form.password.length < 6) {
          this.$toast(this.errmsg.lenpasswordErrorMsg);
          return false;
        }

        if (!this.form.notpassword) {
          this.$toast(this.errmsg.notpasswordErrorMsg);
          return false;
        }

        if (this.form.password != this.form.notpassword) {
          this.$toast(this.errmsg.nopasswordErrorMsg);
          return false;
        }
      }

      if (!this.form.province || !this.form.city || !this.form.area) {
        this.$toast(this.errmsg.areaErrorMsg);
        return false;
      }

      if (!this.form.address) {
        this.$toast(this.errmsg.addressErrorMsg);
        return false;
      }

      if (this.form.mobile) {
        if (!/^1[34578]\d{9}$/.test(this.form.mobile)) {
          this.$toast(this.errmsg.phoneErrorMsg);
          return false;
        }
      }
      return true;
    },
    getData(name) {
      this.merch_id = this.$route.query.id;
      if (this.$route.query.id) {
        let merch_data = this.$getCache(name);
        
        Object.assign(
          this.form,
          merch_data
        );
      } else {
        this.$delCache(name);
      }
    },
    setPlaceholder() {
      if (this.$route.query.id) {
        this.title = "编辑加盟店";
        this.passwordPlaceholder =  "请输入密码(留空则不修改)";
        this.notpasswordPlaceholder =  "请输入确认密码(留空则不修改)";
        
      }else{
        this.title = "添加加盟店";
        this.passwordPlaceholder = "请输入密码";
        this.notpasswordPlaceholder = "请输入确认密码";
        this._resetForm()
      }
    }
  },
  components: {
    SlidedownAnimation
  },
  created() {
    // this.getData("merch_data");
    // this.setPlaceholder();
  },
  activated() {
    this.getData("merch_data");
    this.setPlaceholder();
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.scroll-wrap {
  height: calc(100% - 0.92rem);
  position: fixed;
  top: 0.92rem;
  width: 100%;
}

.vanarea {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.navbar {
  color: #fff;
  background: #2196f3;
  position: fixed;
  top: 0;
  width: 100%;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.form .title {
  padding: 0.4rem 0.3rem;
  font-size: 0.28rem;
  color: rgba(69, 90, 100, 0.49);
}

.submit-container {
  display: flex;
  padding: 0.6rem 0.2rem;
}

.submit-container .submit-btn {
  border-radius: 4px;
}
</style>
